import {
  companySchema,
  EContractorType,
  EGovernmentPhotoIDType,
  EKYCStatus,
  ELLCTaxClassification,
  ETINType,
  Jurisdiction,
  schemes,
  UserAccountType,
  zSchema,
  bankAccountSchema,
} from "@zeal/common";

export const getOnboardingInfoResponseSchema = zSchema.object({
  bankAccount: bankAccountSchema,
  bankAccounts: zSchema.array(bankAccountSchema),
  company: companySchema.pick({
    business_name: true,
    classification: true,
    company_id: true,
    email: true,
    logo_url: true,
    skip_veriff_document_capture: true,
    use_i9_admin_review: true,
    use_i9_location_unchecked: true,
    use_skippable_bank_info: true,
    white_label_id: true,
    persona_theme_id: true,
    force_use_live_veriff: true,
  }),
  employee: zSchema.object({
    email: zSchema.string(),
    password: zSchema.string().optional(),
    hash: zSchema.string().optional(),
    first_name: zSchema.string().optional(),
    last_name: zSchema.string().optional(),
    onboarded: zSchema.boolean(),
    type: zSchema.nativeEnum(EContractorType),
    llc_tax_classification: zSchema
      .nativeEnum(ELLCTaxClassification)
      .optional(),
    tin_type: zSchema.nativeEnum(ETINType).optional(),
    middle_name: zSchema.string(),
    working_state: zSchema.nativeEnum(Jurisdiction),
    ssn: zSchema.string(),
    ein: zSchema.string(),
    business_name: zSchema.string(),
    address: zSchema.string(),
    address_line2: zSchema.string(),
    city: zSchema.string(),
    state: zSchema.nativeEnum(Jurisdiction),
    zip: zSchema.string(),
    dob: zSchema.string().optional(),
    id: zSchema.string().optional(),
    phone_number: zSchema.string().optional(),
    veriff_id: zSchema.string().optional(),
    veriff_stage: zSchema.string().optional(),
    persona_inquiry_id: zSchema.string().optional(),
    doc_type: zSchema.string().optional(),
    kyc_status: zSchema.nativeEnum(EKYCStatus).optional(),
    governmentPhotoIDType: zSchema
      .nativeEnum(EGovernmentPhotoIDType)
      .optional(),
    paycard_requested: zSchema.boolean(),
    instant_pay_enabled: zSchema.boolean(),
  }),
  logoURL: zSchema.string(),
  tokenInfo: zSchema.object({
    companyID: schemes.uuid(),
    employeeID: schemes.mongoObjectId(),
    workerType: zSchema.enum([
      "Worker",
      "contractor",
      "internationalContractor",
    ]),
    testMode: zSchema.boolean(),
    stages: zSchema.object({
      bank_info: zSchema.boolean(),
      contractor_acct: zSchema.boolean(),
      employee_acct: zSchema.boolean(),
      health_insurance: zSchema.boolean(),
      i9: zSchema.boolean(),
      id_scan: zSchema.boolean(),
      instant_pay: zSchema.boolean(),
      paycard: zSchema.boolean(),
      paperwork: zSchema.boolean(),
      payment_method_required: zSchema.boolean(),
      profile_info: zSchema.boolean(),
      survey: zSchema.boolean(),
      type: zSchema.nativeEnum(UserAccountType).optional(),
    }),
    idScanDocuments: zSchema.record(zSchema.boolean()).optional(),
    ignoreKYCStatus: zSchema.boolean(),
    isKYC: zSchema.boolean(),
    useI9Flow: zSchema.boolean().optional(),
    isI9Only: zSchema.boolean(),
    isPayCardOnly: zSchema.boolean(),
  }),
});

export type TGetOnboardingInfoResponseSchema = zSchema.infer<
  typeof getOnboardingInfoResponseSchema
>;
